import RequisitionTable from "./requisition-table";

const Requisition = ({data}: any) => {
    return ( 
        <div>
            <RequisitionTable data={data}/>
        </div>
    );
}
 
export default Requisition;